import {selectFieldFilterSx} from '@hconnect/common/styles'
import {MenuItem, TextField} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {HrocJtbdRole} from '../enums'

type JtbdRolesDropdownSelectorProps = {
  selectedRole: HrocJtbdRole
  onSelectedRoleChanged: (option: HrocJtbdRole) => void
}

export const JtbdRolesDropdownSelector = ({
  selectedRole,
  onSelectedRoleChanged
}: JtbdRolesDropdownSelectorProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  return (
    <TextField
      variant="filled"
      sx={selectFieldFilterSx}
      label={t('jobsToBeDone.label.role')}
      data-test-id="jtbd-roles-dropdown"
      value={selectedRole}
      onChange={(event) => {
        onSelectedRoleChanged(event.target.value as unknown as HrocJtbdRole)
      }}
      select
    >
      {Object.keys(HrocJtbdRole).map((item) => (
        <MenuItem value={item} key={item} id={item} data-test-id={item}>
          {HrocJtbdRole[item]}
        </MenuItem>
      ))}
    </TextField>
  )
}
